'use client'

import { useState, useSyncExternalStore } from 'react'
import { Link } from '@/i18n/navigation'
import { denyConsent, grantConsent } from '@/lib/analytics'
import { consentRequired, readConsentChoice } from '@/lib/consent'

const noopSubscribe = () => () => {}
const needsChoice = () => consentRequired() && readConsentChoice() === null

// Accept and Decline carry equal weight on purpose: consent rules require that
// refusing is as easy as accepting.
const button = 'h-9 flex-1 rounded-lg text-[14px] font-medium transition-colors'

/** Asks visitors from consent regions (EU/EEA/UK/CH) whether analytics may use cookies. */
export function ConsentBanner() {
  // Client-only read (cookie + localStorage); the server snapshot keeps hydration clean.
  const needed = useSyncExternalStore(noopSubscribe, needsChoice, () => false)
  const [answered, setAnswered] = useState(false)
  if (!needed || answered) return null

  const choose = (grant: boolean) => {
    if (grant) grantConsent()
    else denyConsent()
    setAnswered(true)
  }

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-4 bottom-4 z-[1000] rounded-2xl border border-white/10 bg-[#141414] p-5 text-[14px] leading-relaxed text-white/75 shadow-2xl sm:inset-x-auto sm:bottom-6 sm:start-6 sm:w-[360px]"
    >
      <p>
        We use cookies to understand how people use Martini and to improve it.{' '}
        <Link
          href="/privacy"
          className="text-white underline decoration-white/30 underline-offset-4 hover:decoration-white"
        >
          Privacy
        </Link>
      </p>
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          onClick={() => choose(true)}
          className={`${button} bg-white text-black hover:bg-white/90`}
        >
          Accept
        </button>
        <button
          type="button"
          onClick={() => choose(false)}
          className={`${button} border border-white/20 text-white hover:border-white/40 hover:bg-white/[0.06]`}
        >
          Decline
        </button>
      </div>
    </div>
  )
}
